<template>
  <div class="vc-button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VcButtonGroup'
}
</script>
